module.exports = __webpack_public_path__ + "static/media/kawine-logo.37163245.png";